import { Outlet, useLocation } from "react-router-dom";

export function AppShell() {
  const location = useLocation();
  const childMode = location.pathname.startsWith("/play") || location.pathname === "/demo";
  return <main className={childMode ? "app-shell child-mode" : "app-shell adult-mode"}><Outlet /></main>;
}
